export default __webpack_public_path__ + "static/media/p7.7341678d.jpeg";